
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class VoucherMasterGrid extends Serenity.EntityGrid<VoucherMasterRow, any> {
        protected getColumnsKey() { return 'OMS.VoucherMaster'; }
        protected getDialogType() { return VoucherMasterDialog; }
        protected getIdProperty() { return VoucherMasterRow.idProperty; }
        protected getInsertPermission() { return VoucherMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return VoucherMasterRow.localTextPrefix; }
        protected getService() { return VoucherMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        protected getButtons(): Serenity.ToolButton[] {
            return [];
        }
    }


    @Serenity.Decorators.registerClass()
    export class VoucherSelectGrid extends Serenity.EntityGrid<VoucherMasterRow, any> {
        protected getColumnsKey() { return 'OMS.VoucherMaster'; }
        protected getDialogType() { return <any>VoucherMasterDialog; }
        protected getIdProperty() { return VoucherMasterRow.idProperty; }
        protected getLocalTextPrefix() { return VoucherMasterRow.localTextPrefix; }
        protected getService() { return VoucherMasterService.baseUrl; }
        //protected getInsertPermission() { return VoucherMasterRow.insertPermission; }
        //protected getUpdatePermission() { return VoucherMasterRow.updatePermission; }
        //protected getDeletePermission() { return VoucherMasterRow.deletePermission; }
        //protected useViewMode() { return true; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        static ItemType: number;
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            columns.filter(x => x.field != "IsActive");
            columns.filter(x => x.field != "MethodOfVoucherNumbering");
            return columns;
        };

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            return this;
        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);



            return grid;
        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): VoucherMasterRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    }

}